import { apiClient } from './client.js'

export async function fetchCurrentUser() {
  const { data } = await apiClient.get('/auth/me')
  return data.user || null
}

export async function login({ email, password }) {
  const { data } = await apiClient.post('/auth/login', { email, password })
  return data.user
}

export async function logout() {
  await apiClient.post('/auth/logout')
}
